/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React from "react";
import { Link } from "react-router-dom";

/**
 * Página de error 403 - Acceso no autorizado.
 * 
 * Muestra un mensaje de error cuando el usuario intenta acceder
 * a una página o recurso para el que no tiene permisos.
 */
const Unauthorized = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "80vh" }}>
      <h1 className="text-danger">Acceso no autorizado</h1>
      <p>No tienes permiso para ver esta página.</p>
      <Link to="/" className="btn btn-dark mt-3">
        Volver a la página principal
      </Link>
    </div>
  );
};

export default Unauthorized;
